const ja = {
	inputPlaceHolder: '中国語または英語で入力してください',
	error: 'エラーが発生しました。後でもう一度お試しください',
	login: {
		loginTitle: 'PingPong チェックアウトにログイン',
		adminLogin: '管理者ログイン',
		operatorLogin: 'オペレーターログイン',
		email: 'メールアドレス',
		loginPwd: 'ログインパスワード',
		forgetPwd: 'パスワードを忘れましたか?',
		login: 'ログイン',
		noAccount: 'まだアカウントをお持ちでない場合は、',
		register: '無料登録',
		emailTip: 'ログインメールアドレスを入力してください',
		pwdTip: 'ログインパスワードを入力してください',
		pwdLen: 'パスワードは6桁以上である必要があります',
		formatterEmail: '正しい電子メール形式を入力してください',
		noRegister: 'このアカウントは PingPong Checkout を開いていません。まず登録してください。',
		incorrect: 'アカウントまたはパスワードが間違っています。もう一度お試しください。',
		usernameError: '口座番号を入力してください',
		username: 'ログインID',
		operator: 'オペレーターのログイン名',
		companyEmail: '登録メールアドレス',
		passwordLabel: 'パスワードを入力してください',
		accountBand: 'アカウントが有効化されていません',
		authFailed: '認証に失敗しました',
		needRefreshGeeTest: 'もう一度人間と機械の検証を実行してください',
		captchaLoadFailed: '認証の読み込みがタイムアウトしました。もう一度ログインをクリックしてください。',
		verifyCodeError: '間違った SMS 確認コードを 5 回連続で入力したため、アカウントは一時的にロックされました。システムは 3 時間後に自動的にロックを解除します。アカウントのセキュリティを確保するため、確認コードを繰り返し取得または送信しないでください。',
		passwordError: '認証例外によりアカウントが一時的にロックされていますが、3 時間後にシステムが自動的にロックを解除します。アカウントのセキュリティを確保するため、繰り返しログインを試行しないでください。',
		errorTitle: '安全に関するヒント',
		poster: {
			title: 'グローバル決済、信頼の選択',
			oneTitle: 'スピーディーな口座開設、世界中からの決済を受付',
			oneDesc: '70以上の国と地域で、260種類以上の決済手段に対応',
			twoTitle: '世界50以上の主要通貨での決済に対応',
			twoDesc: '米ドル、香港ドル、日本円、韓国ウォン、英ポンド、インドネシアルピアなど',
			threeTitle: '高い可用性と安定性',
			threeDesc: '充実したAPIシステムにより、加盟店との迅速なシステム連携、および安全で安定した取引処理を実現し、お客様のビジネスを保護します。',
			fourTitle: '高機能な決済プラットフォーム',
			fourDesc: '包括的な取引分析、注文管理、リスク管理、店舗管理、ユーザー管理などの各種サービスシステム'
		}
	},
	register: {
		registerTitle: 'PingPong Checkout アカウント登録',
		name: '担当者名',
		companyName: '会社名',
		website: 'ウェブサイトURL',
		email: 'メールアドレスを登録する',
		accountManger: 'アカウントマネージャーの名前 (オプション)',
		mobileNum: '電話番号',
		verifyCode: '認証コード',
		getValidate: '認証コードを取得',
		agreement: 'ピンポンを読んで同意します',
		agreementMerchant: '特別販売者サービス規約',
		registerNow: '登録する',
		nowLogin: '今すぐログインしてください',
		nameInput: 'あなたの名前を入力してください',
		incorrectEmail: 'メールがルールに準拠していない',
		incorrectPhone: '携帯電話番号がルールに準拠していません',
		readAgreement: '特約店の利用規約を必ずお読みいただき、同意してください。',
		readAgreementV2: '「利用規約」と「プライバシーポリシー」を読み、同意してください。',
		sendValidate: '確認コードが正常に送信されました',
		errorValidate: '認証コードエラー',
		resend: '再送信',
		existMobile: 'この携帯電話番号は登録されていますので変更してください。',
		existPhone: '携帯電話番号が登録されています',
		existEmail: 'メールアドレスが登録されています',
		registerSuccess: '登録が成功しました',
		notice: '無事に登録が完了しましたので、\n アカウントを有効にするにはメールを確認してください',
		ok: 'わかりました',
		expireValidate: '認証コードの有効期限が切れていますので、再度取得してください',
		emptyEmail: 'メールアドレスを入力してください',
		emptyPhone: '携帯電話番号を入力してください',
		selectManager: 'アカウントマネージャーを選択してください',
		type: 'タイプ',
		selectClientType: '登録タイプを選択してください',
		emptyClientType: '登録タイプを選択してください',
		switchText: 'すでにアカウントをお持ちですか?',
		nextStep: '次へ',
		emptyCompanyName: '会社名を入力してください',
		emptyWebsite: '会社のURLを入力してください',
		emptyRegisterAddress: '会社の登録場所を選択してください',
		registerAddress: '登記国 / 地域',
		openAccountDialog: {
			title: '買収ビジネスを活性化する',
			content: 'PingPong で他のビジネスに登録しました。ワンクリックで取得ビジネスをアクティブ化し、同じアカウントとパスワードを使用してログインできるようになりました。',
			confirm: 'ワンクリックでアクティベーション',
			cancel: 'キャンセル'
		},
		accountExistsDialog: {
			title: 'メールが占有されています',
			content: 'この電子メール アドレスは他の地域で登録および認証されているため、現在の地域ではビジネスに使用できません。別のメールアドレスで再度ご登録ください。',
			confirm: 'メールアドレスを変更する',
			cancel: 'キャンセル'
		}
	},
	forgetPwd: {
		forgetTitle: 'パスワードの再設定',
		forgetSubTitle: '本人確認のため次の情報を入力してください',
		phone: '電話番号',
		email: 'メールアドレス',
		validateCode: '認証コード',
		getValidateCode: '認証コードを取得',
		confirm: '確認する',
		backLogin: 'ログイン画面へ戻る',
		incorrectPhone: '携帯電話番号がルールに準拠していません',
		notUsedPhone: 'この番号は PingPong Checkout を有効にしていません',
		notUsedEmail: 'このメール アドレスでは PingPong チェックアウトが有効になっていません',
		resend: '再送信',
		phoneInput: '携帯電話番号を入力してください',
		incorrectValidate: '認証コードエラー',
		emptyValidate: '確認コードを入力してください',
		emptyEmail: 'メールアドレスを入力してください',
		incorrectEmail: 'メールがルールに準拠していない',
		newPwdSubTitle: '新しいパスワードを入力してください',
		newPwd: '新しいパスワード',
		confirmNewPwd: '新しいパスワードを再入力してください',
		incorrectPwd: 'パスワードがルールに準拠していません',
		pwdRules: '英語で始まり、任意の 2 種類の数字と大文字と小文字の 6 ～ 20 文字が含まれます',
		strong: '強力な',
		normal: '真ん中',
		weak: '弱い',
		secondInput: 'パスワードが一致しません。',
		successSubmit: '送信成功',
		successModify: 'パスワードの再設定が完了しました',
		newPwdtips: 'これで、新しいパスワードを使用して PingPong Checkout にログインできるようになります。注: 短期間にパスワードを複数回変更したアカウントはロックされます。パスワードを覚えておいてください。',
		emailLabel: 'メールアドレスを入力してください',
		verifyCodeLabel: 'メール認証コード',
		verifyCodeTip: 'メールに記載されている確認コードを入力してください',
		pwdLabel: 'パスワードを入力してください',
		checkPwdLabel: 'パスワード（確認用）',
		verifyCodePhoneLabel: '携帯電話認証コード (SMS は {phoneNo} に送信されます)',
		sendValidate: '確認コードが正常に送信されました',
		expireValidate: '認証コードの有効期限が切れていますので、再度取得してください',
		errorValidate: '認証コードエラー'
	},
	setNewPwd: {
		newPwd: 'ログインパスワードを設定する',
		fstPwd: '初めてご利用になる場合は、デフォルトのパスワードを変更するように求められます。',
		comfirmPwd: 'パスワード（確認用）',
		nextLogin: '次回ログイン時は新しいパスワードをご使用ください。',
		mainLand: '中国本土',
		home: 'トップページ',
		product: '製品',
		faq: 'よくある質問'
	},
	account: {
		title: 'アカウント情報の入力',
		emailTip: 'あなたのメールアドレスはアカウントのログインとして使用されます',
		code: 'メール認証コード',
		codeTip: 'メールに記載されている確認コードを入力してください',
		createAndLogin: 'アカウントを作成してログインする',
		userProtocol: '「利用規約」',
		privacyProtocol: 'プライバシーポリシー',
		service: '収单サービス特別規則',
		usaSpecialTerms: '米国向け特別条件'
	},
	verifyCode: {
		title: 'SMS認証コード',
		content: '6桁の認証コードを携帯電話番号 {phoneNumber}  宛に送信しました。ご確認ください。',
		subTitle: '確認コードを受け取っていませんか?再送信',
		errorCode: '認証コードエラー',
		getValidate: '認証コードを取得',
		resend: '再送信',
		cancel: 'キャンセル',
		continue: '次へ',
		emptyValidate: '確認コードを入力してください',
		expireValidate: '認証コードの有効期限が切れていますので、再度取得してください',
		reviewText: '現在のアカウントが異常です。しばらくしてからもう一度お試しください。'
	},
	passwordValidator: {
		title: 'パスワードは次のとおりです'
	}
}
export default ja
